// Third-party libraries
import React, { Fragment } from "react";

import { Meta } from "../utilities";

function Terms() {
  return (
    <Fragment>
      <Meta
        title="Terms of Service"
        description="Terms of service for Rouleur Derby, almost certainly the best fantasy cycling game in the world."
      />
      <h1>Terms of Service</h1>
      <h4>1. Terms</h4>
      <p>
        By accessing the website at http://www.rouleurderby.com, you are
        agreeing to be bound by these terms of service, all applicable laws and
        regulations, and agree that you are responsible for compliance with any
        applicable local laws. If you do not agree with any of these terms, you
        are prohibited from using or accessing this site. The materials
        contained in this website are protected by applicable copyright and
        trademark law.
      </p>

      <h4>2. Use License</h4>
      <p>
        Permission is granted to temporarily download one copy of the materials
        (information or software) on Rouleur Derby's website for personal,
        non-commercial transitory viewing only. This is the grant of a license,
        not a transfer of title, and under this license you may not:
      </p>
      <ul>
        <li>modify or copy the materials;</li>
        <li>
          use the materials for any commercial purpose, or for any public
          display (commercial or non-commercial);
        </li>
        <li>
          attempt to decompile or reverse engineer any software contained on
          Rouleur Derbys website;
        </li>
        <li>
          remove any copyright or other proprietary notations from the
          materials; 
        </li>

        <li>
          transfer the materials to another person or “mirror” the materials on
          any other server; or
        </li>
        <li>
          use any API endpoints for any unauthorized use.
        </li>
      </ul>

      <p>
        This license shall automatically terminate if you violate any of these
        restrictions and may be terminated by Rouleur Derby at any time. Upon
        terminating your viewing of these materials or upon the termination of
        this license, you must destroy any downloaded materials in your
        possession whether in electronic or printed format.
      </p>
      <h4>3. Disclaimer</h4>
      <p>
        The materials on Rouleur Derby’s website are provided on an “as is”
        basis. Rouleur Derby makes no warranties, expressed or implied, and
        hereby disclaims and negates all other warranties including, without
        limitation, implied warranties or conditions of merchantability, fitness
        for a particular purpose, or non-infringement of intellectual property
        or other violation of rights.
      </p>
      <p>
        Further, Rouleur Derby does not warrant or make any representations
        concerning the accuracy, likely results, or reliability of the use of
        the materials on its website or otherwise relating to such materials or
        on any sites linked to this site.
      </p>
      <p>
        Rouleur Derby exists solely for the entertainment of its players. There
        are no prizes. Should players choose to make actual wagers with others—whether the wagers involve money
        or anything of value—they do so at their own risk and legal peril.
      </p>
      <h4>4. Limitations</h4>
      <p>
        In no event shall Rouleur Derby or its partners be liable for any
        damages (including, without limitation, damages for loss of data or
        profit, or due to business interruption, or to personal relationships)
        arising out of the use or inability to use the materials on Rouleur
        Derby's website, even if Rouleur Derby or a Rouleur Derby authorized
        representative has been notified orally or in writing of the possibility
        of such damage. Because some jurisdictions do not allow limitations on
        implied warranties, or limitations of liability for consequential or
        incidental damages, these limitations may not apply to you.
      </p>

      <h4>5. Accuracy of materials</h4>
      <p>
        The materials appearing on Rouleur Derbys website could include
        technical, typographical, mathematic, or editorial errors. Rouleur Derby does not
        warrant that any of the materials on its website are accurate, complete,
        or current. Rouleur Derby may make changes to the materials contained on
        its website at any time without notice. However, Rouleur Derby does not
        make any commitment to update the materials.
      </p>

      <h4>6. Links</h4>
      <p>
        Rouleur Derby has not reviewed all of the sites linked to its website
        and is not responsible for the contents of any such linked site. The
        inclusion of any link does not imply endorsement by Rouleur Derby of the
        site. Use of any such linked website is at the user’s own risk.
      </p>

      <h4>7. Modifications</h4>
      <p>
        Rouleur Derby may revise these terms of service for its website at any
        time without notice. By using this website you are agreeing to be bound
        by the then current version of these terms of service.
      </p>

      <h4>8. Governing Law</h4>
      <p>
        These terms and conditions are governed by and construed in accordance
        with the laws of Illinois and you irrevocably submit to the exclusive
        jurisdiction of the courts in that state or location.
      </p>
    </Fragment>
  );
}

export default Terms;
